import {
  Text,
  ArrowLeftAndRightIcon,
  ArrowUpAndDownIcon,
} from '@frontend/legacy-components';

export const GrainDirectionFieldLengthwiseLabel = (
  <Text>
    Lengthwise <ArrowLeftAndRightIcon />
  </Text>
);

export const GrainDirectionFieldWidthwiseLabel = (
  <Text>
    Widthwise <ArrowUpAndDownIcon />
  </Text>
);

export const GRAIN_DIRECTION_OPTIONS = [
  { label: 'None', value: null },
  {
    label: GrainDirectionFieldLengthwiseLabel,
    value: 'LW',
  },
  {
    label: GrainDirectionFieldWidthwiseLabel,
    value: 'WW',
  },
];
